import _ from 'lodash';

import { Deliverable, Request } from '../../graphql/generated/graphql';
import { toJSDate } from './datetime';

export const getLatestDeliverable = <D extends Pick<Deliverable, 'createdAt'>>(deliverables: D[]) => {
  const sorted = deliverables.slice().sort((a, b) => toJSDate(a.createdAt).valueOf() - toJSDate(b.createdAt).valueOf());
  return _.last(sorted);
};

export const getLatestModificationRequest = <
  R extends Pick<Request, 'state' | 'targetDeliverableId'>,
  D extends Pick<Deliverable, 'id' | 'createdAt'>
>(
  deliverables: D[],
  modificationRequests: R[],
): R | undefined => {
  const latestDeliverable = getLatestDeliverable(deliverables);
  return _.last(
    modificationRequests.filter(
      (modificationRequest) => modificationRequest?.targetDeliverableId === latestDeliverable?.id,
    ),
  );
};
